<footer class="d-flex justify-content-center">
  <div class="footer-container my-2 mx-2 gap-2 ">
      <img src="images/sage.svg" width="80px" height="44px" alt="sage" />
      <span class="footer-links">© Sage Group plc 2025</span>
      <a href="https://www.sage.com/en-us/legal/" target="_blank" class="footer-links">{{'footer.legal' | translate}}</a>
      <a href="https://www.sage.com/en-us/legal/privacy-and-cookies/" target="_blank" class="footer-links">{{'footer.privacyNoteAndCookies' | translate}}</a>
      <a href="https://www.sage.com/en-us/gdpr/" target="_blank" class="footer-links">{{'footer.generalDataProtection' | translate}}</a>
  </div>
</footer>
